import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { fetchAPI } from "../../lib/utils";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";

/**
 * Per l'atleta: la categoria di peso con cui si leggono i suoi livelli.
 *
 * Con quale modello e' valutato non glielo diciamo: non lo sceglie lui (D13) e
 * non gli cambia niente, per lui e' trasparente. Conta invece la categoria
 * (D6b), ricavata dal peso del profilo, o che il peso manca: senza, i livelli
 * si leggono sulla tabella del genere e l'atleta non saprebbe perche'.
 *
 * L'atleta e' quasi sempre da telefono: una riga piccola, troncata, che apre
 * una finestra con la spiegazione. Nei modelli senza categorie non c'e' niente.
 */
export function ModelBadge({ sport }) {
	const { t } = useLanguage();
	const [data, setData] = useState(null);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		let cancelled = false;
		const query = sport ? `?sport=${encodeURIComponent(sport)}` : "";
		fetchAPI(`/profile/performance-model${query}`)
			.then((payload) => {
				if (!cancelled) setData(payload);
			})
			.catch(() => {
				if (!cancelled) setData(null);
			});
		return () => {
			cancelled = true;
		};
	}, [sport]);

	const bodyweight = data?.bodyweight || null;
	if (!data?.model || bodyweight?.segmentation !== "weight_class") return null;

	const missing = bodyweight.missing || [];
	let classLine = null;
	if (bodyweight.weight_class) {
		classLine = t("scBadgeClass").replace("{label}", bodyweight.weight_class.label);
	} else if (missing.includes("weight")) {
		classLine = t("scBadgeAddWeight");
	} else if (missing.includes("gender")) {
		classLine = t("scBadgeAddGender");
	}
	if (!classLine) return null;

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="flex max-w-full min-w-0 items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground"
			>
				<Info className="w-3.5 h-3.5 text-volt shrink-0" />
				<span className="truncate">{classLine}</span>
			</button>
			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="bg-card border-border max-w-md">
					<DialogDescription className="hidden" />
					<DialogHeader>
						<DialogTitle className="pr-6">{t("scBadgeInfoTitle")}</DialogTitle>
					</DialogHeader>
					<div className="space-y-2 text-sm text-muted-foreground">
						<p className="text-foreground">{classLine}</p>
						<p>{t("scBadgeInfoClass")}</p>
						{bodyweight.coefficient === "sinclair" && <p>{t("scBadgeInfoSinclair")}</p>}
					</div>
				</DialogContent>
			</Dialog>
		</>
	);
}
